import Comment from './Comment'

export default Comment
// eslint-disable-next-line import/export
export * from './Comment'
